import { render, staticRenderFns } from "./StatisticsReworkAdmissionsFacultyView.vue?vue&type=template&id=0970fc35"
import script from "./StatisticsReworkAdmissionsFacultyView.vue?vue&type=script&lang=js"
export * from "./StatisticsReworkAdmissionsFacultyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports